import React from 'react'
import { UsageReport } from '../modules/dashboard'

export const UsageReportPage = () => {
    return (
        <UsageReport />
    );
};
